import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showNotification } from 'react-admin';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import api from '~config/api';

const TOTAL = 100;

const styles = {
  row: { display: 'block', marginBottom: 16, maxWidth: 360 },
  total: { margin: '24px 0', fontSize: 16 },
  totalError: { color: '#b71c1c' },
  actions: { display: 'flex', gap: 12 }
};

function errorMessage(data) {
  if (!data) return 'No se pudieron guardar los pesos';
  if (Array.isArray(data)) return data.join(' ');
  return Object.values(data).flat().join(' ');
}

// Etapa weights must add up to 100, so they are edited together rather than per etapa.
class EtapaWeights extends Component {
  state = { etapas: [], weights: {}, saving: false };

  componentDidMount() {
    api.get('/etapas/').then(response => {
      if (!response.ok) {
        this.props.showNotification('No se pudieron cargar las etapas', 'warning');
        return;
      }
      const etapas = [...response.data].sort((a, b) => a.order - b.order);
      const weights = etapas.reduce((acc, etapa) => ({ ...acc, [etapa.id]: String(etapa.weight) }), {});
      this.setState({ etapas, weights });
    });
  }

  handleChange = id => event => {
    const { value } = event.target;
    this.setState(state => ({ weights: { ...state.weights, [id]: value } }));
  };

  isValidWeight = value => /^\d+$/.test(value) && Number(value) <= TOTAL;

  total = () => this.state.etapas.reduce((sum, etapa) => sum + (Number(this.state.weights[etapa.id]) || 0), 0);

  canSave = () =>
    !this.state.saving &&
    this.state.etapas.length > 0 &&
    this.state.etapas.every(etapa => this.isValidWeight(this.state.weights[etapa.id])) &&
    this.total() === TOTAL;

  handleSave = () => {
    const payload = this.state.etapas.map(etapa => ({ id: etapa.id, weight: Number(this.state.weights[etapa.id]) }));
    this.setState({ saving: true });
    api.put('/etapas/weights/', payload).then(response => {
      this.setState({ saving: false });
      if (response.ok) {
        this.props.showNotification('Pesos guardados');
        this.props.history.push('/etapas');
      } else {
        this.props.showNotification(errorMessage(response.data), 'warning');
      }
    });
  };

  render() {
    const total = this.total();
    return (
      <Card>
        <CardContent>
          <h2>Pesos de las etapas</h2>
          <p>
            El peso de cada etapa es su participación en el avance total de un proyecto. Los pesos deben sumar{' '}
            {TOTAL}.
          </p>
          {this.state.etapas.map(etapa => (
            <TextField
              key={etapa.id}
              style={styles.row}
              label={etapa.name}
              type="number"
              inputProps={{ min: 0, max: TOTAL, step: 1 }}
              value={this.state.weights[etapa.id]}
              error={!this.isValidWeight(this.state.weights[etapa.id])}
              onChange={this.handleChange(etapa.id)}
              fullWidth
            />
          ))}
          <div style={total === TOTAL ? styles.total : { ...styles.total, ...styles.totalError }}>
            <b>Total:</b> {total} / {TOTAL}
          </div>
          <div style={styles.actions}>
            <Button variant="contained" color="primary" disabled={!this.canSave()} onClick={this.handleSave}>
              <SaveIcon style={{ marginRight: 8 }} />
              Guardar
            </Button>
            <Button onClick={() => this.props.history.push('/etapas')}>Cancelar</Button>
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default connect(null, { showNotification })(EtapaWeights);
